export enum ProductCategory {
    SALES_ALL = 'SALES_ALL',
    SALES_NEW = 'SALES_NEW',
    SALES_USED = 'SALES_USED',
    DISCOUNT = 'DISCOUNT',
    RENTAL_ALL = 'RENTAL_ALL',
    RENTAL_SANITARY = 'RENTAL_SANITARY',
    RENTAL_STORAGE = 'RENTAL_STORAGE',
    RENTAL_OFFICE = 'RENTAL_OFFICE',
}
